import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";



export function ErrorWrapper({ children }: { children: React.ReactNode }) {
    const location = useLocation();


    const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
        return (

            // <div role="alert" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "1rem", color: "red", textAlign: "center", }}   >
            //     {/* <p style={{marginBottom:"0px"}}>Oops!</p> */}
            //     <p style={{ fontSize: "2rem" }}> Something went wrong. Please contact the support team.</p>
            //     {/* <pre>{error.message}</pre> */}
            //     {/* <Button size="small" variant="outlined" onClick={resetErrorBoundary}>Try Again</Button> */}
            // </div>


            //         <div
            //   role="alert"
            //   style={{
            //     display: "flex",
            //     flexDirection: "column",
            //     justifyContent: "center",
            //     alignItems: "center",
            //     padding: "2rem",
            //     minHeight: "60vh",
            //     backgroundColor: "#fafafa",
            //     color: "#333",
            //     textAlign: "center",
            //   }}
            // >
            //   <h2 style={{ fontSize: "1.75rem", fontWeight: 600, color: "#d32f2f" }}>
            //     Oops! Something went wrong
            //   </h2>
            //   <p style={{ fontSize: "1rem", maxWidth: "500px", margin: "1rem 0" }}>
            //     An unexpected error occurred while loading the application.  
            //     Please try refreshing the page, or contact our support team if the
            //     issue persists.
            //   </p>
            //   {/* Optional retry button */}

            //   <Button
            //     size="small"
            //     variant="contained"
            //     color="primary"
            //     onClick={resetErrorBoundary}    
            //   >
            //     Try Again
            //   </Button> 

            // </div>


            <Box
            role="alert"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            minHeight="60vh"
            px={3}
            py={4}
            sx={{ backgroundColor: "#f9f9f9", color: "#333" }}
          >
            <Typography
              variant="h5"
              fontWeight={600}
              gutterBottom
              sx={{ color: "primary.main" }}
            >
              Something didn’t load as expected
            </Typography>
      
                <Typography variant="body1" sx={{ maxWidth: 500, mb: 3 }}>
                    An unexpected error occurred.
                    Please try again, and if the problem continues, our support team will be
                    happy to help.
                </Typography>
            <Button
              size="medium"
              variant="contained"
              color="primary"
              onClick={resetErrorBoundary}
            >
              Retry
            </Button>
          </Box>

        );
    };


    const logError = (error: Error, info: React.ErrorInfo) => {
        console.log("🔴 error.name:", error?.name);
        console.log("🔴 error.message:", error?.message);
        console.log("🔴 error.stack:", error?.stack);
        console.log("🔴 info.componentStack:", info?.componentStack);

        // 🚨 Detect if the error is related to dynamic chunk loading failure
        // This typically happens after a new deployment when the browser still tries to use old cached JS files
        const isChunkLoadError = error?.name === "ChunkLoadError" || error?.message?.includes("Loading chunk");
        if (isChunkLoadError) {
            console.warn("Detected ChunkLoadError. Reloading app...");

            // This helps load the latest version of the app and avoids broken state caused by old chunks
            // The delay allows fallback UI to briefly render (good UX touch)
            setTimeout(() => {
                window.location.reload();  // Hard reload to get fresh chunks from the server
            }, 300);
        }
    };


    return (
        <ErrorBoundary     resetKeys={[location?.pathname]}  // ✅ Proper way
        FallbackComponent={Fallback} onError={logError} >
            {children}
        </ErrorBoundary>
    );
};

